import { render, staticRenderFns } from "./CourseSetEdit.vue?vue&type=template&id=9f61df88&"
import script from "./CourseSetEdit.vue?vue&type=script&lang=js&"
export * from "./CourseSetEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports